import {
    FormControl,
    FormControlProps,
    FormHelperText,
    InputLabel,
    MenuItem,
    Select,
    SelectProps,
    SxProps,
    Typography,
    useTheme,
} from '@mui/material'
import { Control, Controller, FieldValues, Path } from 'react-hook-form'

const FormSelect = <T extends FieldValues>({
    name,
    props,
    control,
    options,
    sx,
    placeholder,
    controlProps,
    variant,

    onChange,
}: {
    variant?: SelectProps['variant']
    name: Path<T>
    control: Control<T>
    options: { label: string; value: any }[]
    props?: SelectProps
    controlProps?: FormControlProps
    sx?: SxProps
    placeholder?: string
    onChange?: (
        e:
            | React.ChangeEvent<HTMLInputElement>
            | (Event & {
                  target: {
                      value: unknown
                      name: string
                  }
              })
    ) => void
}) => {
    const theme = useTheme()
    return (
        <Controller
            name={name}
            control={control}
            render={(renderProps) => (
                <FormControl
                    {...controlProps}
                    // sx={sx}
                    error={!!renderProps.fieldState.error}
                    variant={variant}
                >
                    {!!props?.label ? (
                        <InputLabel>{props?.label}</InputLabel>
                    ) : null}
                    <Select
                        {...props}
                        name={name}
                        variant={variant}
                        label={props?.label}
                        value={renderProps.field.value || ''}
                        displayEmpty={props?.label ? undefined : true}
                        onChange={(e) => {
                            renderProps.field.onChange(e)
                            onChange?.(e)
                        }}
                        // inputProps={{ 'aria-label': 'Without label' }}
                    >
                        {placeholder ? (
                            <MenuItem value="" disabled>
                                <Typography color={theme.palette.neutrals[500]}>
                                    {placeholder}
                                </Typography>
                            </MenuItem>
                        ) : null}
                        {options.map((el, i) => (
                            <MenuItem
                                key={`${name}_select_${i}`}
                                value={el.value}
                            >
                                {el.label}
                            </MenuItem>
                        ))}
                    </Select>
                    {!!renderProps.fieldState.error?.message ? (
                        <FormHelperText>
                            {renderProps.fieldState.error.message}
                        </FormHelperText>
                    ) : undefined}
                </FormControl>
            )}
        />
    )
}

export default FormSelect
